<template>
  <footer class="rodape">
    <div class="ui container">
      <div class=" ui stackable two column grid">
        <div class="column">
          <div class="ui vertical text menu">
        <div class="header item">Consultorio de Guarulhos</div>
        <a class="item"  :href="`tel:${dados.telefones.numero.replace(/ /g,'')}`">
          <i class="phone icon"></i>
          {{ dados.telefones.numero }}
        </a>
        <div class="item">
          <i class="whatsapp icon"></i>
          <p>Agende sua consulta pelo WhatsApp
            <br>
            <a target="_blank" :href="`http://wa.me/055${dados.telefones.whatsapp.replace(/ /g,'')}`">{{dados.telefones.whatsapp}}</a>
          </p>
        </div>
        <div class="item">
          <i class="map marker alternat icon"></i>
          <div>
            {{dados.endereco.rua}}, {{dados.endereco.numero}} - {{dados.endereco.cidade}}, {{dados.endereco.estado}}
            <br>Cep {{dados.endereco.cep}}
            <a target="_blank" :href="dados.endereco.shareLink">Ver no Google Maps</a>
          </div>
        </div>
      </div>
        </div>

        <div class="column flex">
          <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fdracamilazapparoli%2F&tabs&width=340&height=154&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=318763608693315" width="340" height="154" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
        </div>
      </div>
      
    </div>
    <div class="copyright">Odontologia © 2018. Todos os direitos reservados.
      <p>
        Desenvolvido por
        <img src="../assets/images/aodesign.png">
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  props: ['dados']
};
</script>

<style lang="sass" scoped>
.flex
  display: flex !important
iframe
  margin: auto 0 auto auto!important

</style>


